/*
 * Envíos y Entregas — Carrito (lógica persistente)
 *
 * El bloque HTML lo imprime el snippet bucarest-cart-shipping.liquid, pero el
 * carrito de este tema se actualiza vía AJAX (Section Rendering API): cuando
 * el HTML nuevo se inyecta con innerHTML, los navegadores NO ejecutan los
 * <script> que vengan dentro de ese HTML. Por eso esta lógica vive acá, en un
 * archivo cargado UNA sola vez desde theme.liquid, y usa un MutationObserver
 * para detectar el bloque cada vez que aparece: carga inicial de la página,
 * apertura del cajón de carrito, o refresco tras agregar/quitar productos.
 */
(function(){

  var ORDER_CUTOFF_HOUR = 13;
  var PICKUP_CUTOFF_HOUR = 18;

  /* Feriados Chile 2026 — VERIFICAR cada año contra el Diario Oficial */
  var HOLIDAYS_CL_2026 = ['2026-01-01','2026-04-03','2026-04-04','2026-05-01','2026-05-21','2026-06-29','2026-07-16','2026-08-15','2026-09-18','2026-09-19','2026-10-12','2026-10-31','2026-11-01','2026-12-08','2026-12-25'];
  var HOLIDAY_SET = {};
  HOLIDAYS_CL_2026.forEach(function(d){ HOLIDAY_SET[d] = true; });

  /* Prefijo de código postal (3 dígitos) -> región. Mismo mapeo que el bloque de producto (PMAP), reducido a solo la región. */
  var REGION_BY_ZIP_PREFIX = {
    '100':'Arica','104':'Arica','107':'Arica','108':'Arica',
    '110':'Tarapaca','113':'Tarapaca','114':'Tarapaca','115':'Tarapaca','116':'Tarapaca','117':'Tarapaca','118':'Tarapaca',
    '124':'Antofagasta','130':'Antofagasta','131':'Antofagasta','132':'Antofagasta','134':'Antofagasta','136':'Antofagasta','139':'Antofagasta','141':'Antofagasta','142':'Antofagasta',
    '149':'Atacama','150':'Atacama','153':'Atacama','157':'Atacama','158':'Atacama','161':'Atacama','163':'Atacama','164':'Atacama','165':'Atacama',
    '170':'Coquimbo','174':'Coquimbo','175':'Coquimbo','176':'Coquimbo','177':'Coquimbo','178':'Coquimbo','184':'Coquimbo','187':'Coquimbo','188':'Coquimbo','189':'Coquimbo','190':'Coquimbo','193':'Coquimbo','194':'Coquimbo','195':'Coquimbo','196':'Coquimbo',
    '203':'Valparaiso','204':'Valparaiso','205':'Valparaiso','206':'Valparaiso','207':'Valparaiso','210':'Valparaiso','212':'Valparaiso','213':'Valparaiso','214':'Valparaiso','217':'Valparaiso','219':'Valparaiso','220':'Valparaiso','221':'Valparaiso','222':'Valparaiso','223':'Valparaiso','224':'Valparaiso','226':'Valparaiso','228':'Valparaiso','229':'Valparaiso','230':'Valparaiso','231':'Valparaiso','233':'Valparaiso','234':'Valparaiso','243':'Valparaiso','248':'Valparaiso','249':'Valparaiso','250':'Valparaiso','251':'Valparaiso','252':'Valparaiso','260':'Valparaiso','266':'Valparaiso','268':'Valparaiso','269':'Valparaiso','270':'Valparaiso','271':'Valparaiso','272':'Valparaiso','277':'Valparaiso','650':'Valparaiso',
    '282':'OHiggins','288':'OHiggins','289':'OHiggins','290':'OHiggins','291':'OHiggins','292':'OHiggins','293':'OHiggins','294':'OHiggins','295':'OHiggins','296':'OHiggins','297':'OHiggins','298':'OHiggins','299':'OHiggins','300':'OHiggins','301':'OHiggins','302':'OHiggins','303':'OHiggins','307':'OHiggins','309':'OHiggins','310':'OHiggins','311':'OHiggins','312':'OHiggins','313':'OHiggins','314':'OHiggins','315':'OHiggins','316':'OHiggins','317':'OHiggins','322':'OHiggins','323':'OHiggins','324':'OHiggins','325':'OHiggins','326':'OHiggins','327':'OHiggins',
    '334':'Maule','336':'Maule','337':'Maule','338':'Maule','339':'Maule','340':'Maule','341':'Maule','342':'Maule','343':'Maule','346':'Maule','350':'Maule','351':'Maule','352':'Maule','353':'Maule','354':'Maule','355':'Maule','356':'Maule','357':'Maule','358':'Maule','360':'Maule','361':'Maule','362':'Maule','363':'Maule','364':'Maule','365':'Maule','366':'Maule','369':'Maule','371':'Maule','372':'Maule',
    '378':'Nuble','382':'Nuble','384':'Nuble','385':'Nuble','386':'Nuble','387':'Nuble','388':'Nuble','389':'Nuble','390':'Nuble','391':'Nuble','392':'Nuble','393':'Nuble','394':'Nuble','395':'Nuble','396':'Nuble','397':'Nuble','398':'Nuble','399':'Nuble','400':'Nuble','401':'Nuble','402':'Nuble',
    '403':'Biobio','410':'Biobio','413':'Biobio','415':'Biobio','416':'Biobio','417':'Biobio','418':'Biobio','419':'Biobio','421':'Biobio','423':'Biobio','426':'Biobio','435':'Biobio','436':'Biobio','437':'Biobio','438':'Biobio','439':'Biobio','440':'Biobio','441':'Biobio','444':'Biobio','447':'Biobio','448':'Biobio','449':'Biobio','450':'Biobio','451':'Biobio','452':'Biobio','453':'Biobio','454':'Biobio','455':'Biobio','456':'Biobio','457':'Biobio','458':'Biobio','459':'Biobio','460':'Biobio',
    '465':'Araucania','467':'Araucania','468':'Araucania','469':'Araucania','470':'Araucania','471':'Araucania','472':'Araucania','473':'Araucania','474':'Araucania','475':'Araucania','476':'Araucania','478':'Araucania','481':'Araucania','485':'Araucania','486':'Araucania','487':'Araucania','488':'Araucania','489':'Araucania','490':'Araucania','491':'Araucania','492':'Araucania','493':'Araucania','494':'Araucania','495':'Araucania','496':'Araucania','497':'Araucania','498':'Araucania','499':'Araucania','500':'Araucania','501':'Araucania','502':'Araucania','503':'Araucania','504':'Araucania',
    '509':'Los Rios','515':'Los Rios','516':'Los Rios','517':'Los Rios','518':'Los Rios','519':'Los Rios','520':'Los Rios','521':'Los Rios','522':'Los Rios','523':'Los Rios','524':'Los Rios','525':'Los Rios',
    '529':'Los Lagos','535':'Los Lagos','536':'Los Lagos','537':'Los Lagos','538':'Los Lagos','539':'Los Lagos','540':'Los Lagos','548':'Los Lagos','550':'Los Lagos','555':'Los Lagos','556':'Los Lagos','557':'Los Lagos','558':'Los Lagos','559':'Los Lagos','560':'Los Lagos','561':'Los Lagos','562':'Los Lagos','570':'Los Lagos','571':'Los Lagos','572':'Los Lagos','573':'Los Lagos','574':'Los Lagos','575':'Los Lagos','576':'Los Lagos','577':'Los Lagos','578':'Los Lagos','579':'Los Lagos','585':'Los Lagos','586':'Los Lagos','587':'Los Lagos','588':'Los Lagos',
    '595':'Aysen','596':'Aysen','600':'Aysen','601':'Aysen','602':'Aysen','605':'Aysen','606':'Aysen','610':'Aysen','611':'Aysen','612':'Aysen',
    '616':'Magallanes','620':'Magallanes','624':'Magallanes','625':'Magallanes','626':'Magallanes','630':'Magallanes','631':'Magallanes','632':'Magallanes','635':'Magallanes','636':'Magallanes',
    '750':'Metropolitan','755':'Metropolitan','760':'Metropolitan','765':'Metropolitan','770':'Metropolitan','775':'Metropolitan','780':'Metropolitan','785':'Metropolitan','790':'Metropolitan','800':'Metropolitan','805':'Metropolitan','810':'Metropolitan','815':'Metropolitan','820':'Metropolitan','825':'Metropolitan','830':'Metropolitan','832':'Metropolitan','835':'Metropolitan','840':'Metropolitan','845':'Metropolitan','850':'Metropolitan','855':'Metropolitan','860':'Metropolitan','865':'Metropolitan','870':'Metropolitan','875':'Metropolitan','880':'Metropolitan','885':'Metropolitan','890':'Metropolitan','895':'Metropolitan','900':'Metropolitan','905':'Metropolitan','910':'Metropolitan','915':'Metropolitan','920':'Metropolitan','925':'Metropolitan','930':'Metropolitan','934':'Metropolitan','938':'Metropolitan','942':'Metropolitan','946':'Metropolitan','948':'Metropolitan','950':'Metropolitan','954':'Metropolitan','956':'Metropolitan','958':'Metropolitan','962':'Metropolitan','963':'Metropolitan','965':'Metropolitan','966':'Metropolitan'
  };

  var T = {
    es: {title:'Envíos y Entregas', deliveryOn:'Entrega/envío estimado', between:'entre el', andTo:'y el', marble:'Uno o más productos se envían a todo Chile, se pagan por separado.', quote:'Solicitar cotización', info:'Más información', checkout:'El costo y la fecha final se confirman en el Checkout.', pickupFrom:'Retiro en tienda desde el'},
    en: {title:'Shipping & Delivery', deliveryOn:'Delivery/shipping estimate', between:'between', andTo:'and', marble:'One or more items ship to all Chile, paid separately.', quote:'Request quote', info:'More info', checkout:'Cost and final date are confirmed at Checkout.', pickupFrom:'In-store pickup from'},
    fr: {title:'Livraison', deliveryOn:'Livraison/expédition estimée', between:'entre le', andTo:'et le', marble:'Un ou plusieurs articles sont expédiés séparément.', quote:'Demander un devis', info:"Plus d'infos", checkout:'Le coût et la date finale sont confirmés au paiement.', pickupFrom:'Retrait en magasin dès le'},
  };

  function pad2(n){ return n<10 ? '0'+n : ''+n; }
  function toISO(d){ return d.getFullYear()+'-'+pad2(d.getMonth()+1)+'-'+pad2(d.getDate()); }

  function baseToday(cutoffHour){
    var d = new Date();
    if(d.getHours() >= cutoffHour){ d.setDate(d.getDate()+1); }
    d.setHours(0,0,0,0);
    return d;
  }

  function nextDeliveryDate(totalDays){
    var d = baseToday(ORDER_CUTOFF_HOUR);
    d.setDate(d.getDate()+totalDays);
    while(true){
      var dow = d.getDay();
      if((dow===1||dow===3||dow===5) && !HOLIDAY_SET[toISO(d)]) break;
      d.setDate(d.getDate()+1);
    }
    return d;
  }

  function deliveryWindow(totalDays){
    var from = nextDeliveryDate(totalDays);
    var to = new Date(from);
    to.setDate(to.getDate()+5);
    return [from, to];
  }

  /* Retiro en tienda: no depende de embalaje ni geolocalización, solo de si
     algún producto del carrito necesita restauración. La tienda abre
     Lun-Sáb (no domingo), y los feriados también cierran. */
  function nextPickupDate(totalDays){
    var d = baseToday(PICKUP_CUTOFF_HOUR);
    d.setDate(d.getDate()+totalDays);
    while(true){
      var dow = d.getDay();
      if(dow!==0 && !HOLIDAY_SET[toISO(d)]) break;
      d.setDate(d.getDate()+1);
    }
    return d;
  }

  function extraDays(rg){
    var r = (rg||'').toLowerCase();
    if(r.indexOf('aysen')!==-1 || r.indexOf('aysén')!==-1 || r.indexOf('magallanes')!==-1) return 3;
    if(r.indexOf('arica')!==-1 || r.indexOf('tarapaca')!==-1 || r.indexOf('tarapacá')!==-1) return 2;
    if(r.indexOf('antofagasta')!==-1 || r.indexOf('atacama')!==-1 || r.indexOf('copiapo')!==-1) return 1;
    return 1;
  }

  function regionFromZip(zip){
    var pref = (zip||'').replace(/\D/g,'').slice(0,3);
    return REGION_BY_ZIP_PREFIX[pref] || '';
  }

  function isRMFromZip(zip){
    return regionFromZip(zip) === 'Metropolitan';
  }

  function computeTotals(items, isRM, region){
    var maxEstadoDias = 0;
    var maxEmbalajeDias = 0;
    var hayMarmol = false;
    items.forEach(function(it){
      maxEstadoDias = Math.max(maxEstadoDias, it.estadoDias||0);
      if(it.marmol) hayMarmol = true;
      if(!isRM){
        var kg = (it.weightG||0)/1000;
        if(kg > 35){
          maxEmbalajeDias = Math.max(maxEmbalajeDias, it.mueble ? 3 : 2);
        }
      }
    });
    var geoDias = isRM ? 1 : extraDays(region);
    return {geoDias: geoDias, estadoDias: maxEstadoDias, embalajeDias: maxEmbalajeDias, hayMarmol: hayMarmol};
  }

  function renderBlock(el, g){
    var content = el.querySelector('.bucarest-cart-shipping-content');
    if(!content) return;

    var items = [];
    try { items = JSON.parse(el.dataset.items || '[]'); } catch(e) {}
    if(!items.length){ el.style.display = 'none'; return; }
    el.style.display = 'flex';

    var locale = (el.dataset.locale || 'es').substring(0,2);
    function _t(k){ return (T[locale]||T.es)[k] || T.es[k] || k; }
    function fmtDate(d){
      var lc = locale==='en' ? 'en-US' : (locale==='fr' ? 'fr-FR' : 'es-CL');
      return new Intl.DateTimeFormat(lc, {day:'numeric', month:'long'}).format(d);
    }
    var masInfo = ' <a href="https://bucarestart.cl/policies/shipping-policy" style="text-decoration:underline;color:inherit;">'+_t('info')+'</a>.';

    var country = g.country_code;
    var zip = g.postal;
    var marbleLine = '';

    var maxEstadoDias = 0;
    items.forEach(function(it){ maxEstadoDias = Math.max(maxEstadoDias, it.estadoDias||0); });
    var pickupDate = nextPickupDate(1+maxEstadoDias);
    var pickupTxt = _t('pickupFrom')+' '+fmtDate(pickupDate)+'.';
    var pickupLine = '<p style="margin:0 0 2px 0;">'+_t('pickupFrom')+' <strong>'+fmtDate(pickupDate)+'</strong>.</p>';

    var totals;
    if(country === 'CL'){
      var isRM = isRMFromZip(zip);
      var region = regionFromZip(zip);
      totals = computeTotals(items, isRM, region);
    } else {
      totals = {geoDias: null, hayMarmol: items.some(function(it){ return it.marmol; })};
    }

    if(totals.hayMarmol){
      marbleLine = '<p style="margin:0 0 2px 0;">'+_t('marble')+' <a href="https://api.whatsapp.com/send?phone=56929466721&text='+encodeURIComponent('Hola Bucarest Art, me gustaría cotizar el envío de mi carrito')+'" target="_blank" rel="noopener noreferrer" style="text-decoration:underline;color:inherit;">'+_t('quote')+'</a>.</p>';
    }

    if(totals.geoDias === null){
      content.innerHTML = '<p style="font-weight:700;font-size:1.15em;margin:0 0 6px 0;">'+_t('title')+'</p>'+marbleLine+'<p style="margin:0 0 2px 0;">'+_t('checkout')+masInfo+'</p>'+pickupLine;
      syncCartMetafield(pickupTxt);
      return;
    }

    var totalDias = totals.estadoDias + totals.embalajeDias + totals.geoDias;
    var w = deliveryWindow(totalDias);
    var shipTxt = _t('deliveryOn')+' '+_t('between')+' '+fmtDate(w[0])+' '+_t('andTo')+' '+fmtDate(w[1])+'.';
    var dt = _t('deliveryOn')+' <strong>'+_t('between')+' '+fmtDate(w[0])+' '+_t('andTo')+' '+fmtDate(w[1])+'</strong>.'+masInfo;
    content.innerHTML = '<p style="font-weight:700;font-size:1.15em;margin:0 0 6px 0;">'+_t('title')+'</p>'+marbleLine+pickupLine+'<p style="margin:0;">'+dt+'</p>';
    syncCartMetafield(pickupTxt+'\n'+shipTxt);
  }

  /* ---- Sincroniza el texto calculado con un metacampo del carrito, que Shopify
     copia automáticamente al pedido (capacidad "cart to order copyable" activada
     en la definición del metacampo custom.entrega_estimada_texto del pedido). ---- */
  var STOREFRONT_TOKEN = '57cfb09e30afb794dce0dfc9bc61fd52';
  var CART_METAFIELD_NAMESPACE = 'custom';
  var CART_METAFIELD_KEY = 'entrega_estimada_texto';

  function syncCartMetafield(text){
    try{
      if(sessionStorage.getItem('bucarest_cart_meta_last') === text) return;
    }catch(e){}

    var shopDomain = (window.Shopify && window.Shopify.shop) || null;
    if(!shopDomain) return;

    fetch('/cart.js')
      .then(function(res){ return res.json(); })
      .then(function(cart){
        if(!cart || !cart.token) return;
        var cartGid = 'gid://shopify/Cart/'+cart.token;
        var query = 'mutation setEntregaMeta($cartId: ID!, $value: String!) {'+
          ' cartMetafieldsSet(metafields: [{ownerId: $cartId, namespace: "'+CART_METAFIELD_NAMESPACE+'", key: "'+CART_METAFIELD_KEY+'", type: "multi_line_text_field", value: $value}]) {'+
          '   userErrors { field message }'+
          ' }'+
          '}';
        return fetch('https://'+shopDomain+'/api/2026-07/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
          },
          body: JSON.stringify({query: query, variables: {cartId: cartGid, value: text}})
        });
      })
      .then(function(res){ return res && res.json(); })
      .then(function(json){
        if(json && json.data && json.data.cartMetafieldsSet && json.data.cartMetafieldsSet.userErrors && json.data.cartMetafieldsSet.userErrors.length){
          return;
        }
        try{ sessionStorage.setItem('bucarest_cart_meta_last', text); }catch(e){}
      })
      .catch(function(){});
  }

  function getGeoAndRender(el){
    function fallback(){ renderBlock(el, {country_code:'CL', postal:''}); }

    try{
      var cached = sessionStorage.getItem('bucarest_geo');
      if(cached){ renderBlock(el, JSON.parse(cached)); return; }
    } catch(e){}

    fetch('https://api.ipgeolocation.io/ipgeo?apiKey=bc205aaabd754e1388b126c5ca0cd061')
      .then(function(res){ return res.json(); })
      .then(function(d){
        if(!d || d.message || !d.country_code2){ fallback(); return; }
        var g = {country_code: d.country_code2, postal: d.zipcode};
        try{ sessionStorage.setItem('bucarest_geo', JSON.stringify(g)); }catch(e){}
        renderBlock(el, g);
      })
      .catch(fallback);
  }

  function initAll(root){
    (root || document).querySelectorAll('.bucarest-cart-shipping:not([data-bucarest-init])').forEach(function(el){
      el.setAttribute('data-bucarest-init', '1');
      getGeoAndRender(el);
    });
  }

  function start(){
    initAll(document);
    var observer = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if(node.nodeType !== 1) return;
          if(node.matches && node.matches('.bucarest-cart-shipping')){
            initAll(node.parentNode || document);
          } else if(node.querySelector) {
            initAll(node);
          }
        });
      });
    });
    observer.observe(document.body, {childList: true, subtree: true});
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
